module.exports = __webpack_public_path__ + "img/act_icon_04.9f3e5b5.png";